import component from './PhFunnel.vue_vue_type_script_lang.vue.js';
export { default } from './PhFunnel.vue_vue_type_script_lang.vue.js';
import { render } from './PhFunnel.vue_vue_type_template_id_65fd3556_lang.vue.js';

component.render = render;
